import React from 'react'
import { t } from 'ttag'

import { InformationModal } from 'components/modals/common/InformationModal/InformationModal'

export const AbortEditInterviewTemplateModal = ({
  onClose,
  onConfirm,
  isOpen,
}) => (
  <InformationModal
    confirmLabel={t`Go back`}
    message={t`Editing for this particular interview template is disabled.`}
    text={t`You cannot edit this Interview template because it is used in a Job position that has Interviews in progress.`}
    title={t`Edit a template`}
    {...{ onClose, onConfirm, isOpen }}
  />
)
